var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10287 17.3882L1.21986 34.7765L7.37205 34.8882L13.5242 35L13.6475 28.5034L13.7708 22.0069L18.9126 28.4922L24.0544 34.9775H29.1102H34.166V17.4887V0H28.1259H22.0857L21.9625 6.48531L21.8392 12.9706L16.6974 6.48531L11.5555 0H6.27071H0.986328L1.10287 17.3882ZM17.805 16.3465L27.2182 28.2333L27.337 16.3281C27.4387 6.11422 27.5503 4.42244 28.1214 4.42244C28.6965 4.42244 28.787 6.20388 28.787 17.5181C28.787 29.6742 28.7319 30.6045 28.0178 30.4811C27.5951 30.4079 23.006 25.0202 17.8202 18.5083L8.39181 6.66824L8.27303 18.6116C8.17128 28.8588 8.05966 30.555 7.4886 30.555C6.91349 30.555 6.82295 28.7768 6.82295 17.4887C6.82295 5.30532 6.87584 4.42365 7.60738 4.44134C8.1139 4.4534 11.7281 8.67281 17.805 16.3465Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.65f09b6e.svg";
export { ForwardRef as ReactComponent };